import { Directive, Input } from '@angular/core';

export type ButtonType = 'back' | 'next' | 'finish' | 'close';

@Directive({
    selector: 'mpro-wizard-button'
})
export class WizardButtonComponent {
    @Input() public type: ButtonType;
    @Input() public label: string;
}